import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { NotReady } from '@components'
import { parseConnectAppId, parseConnectInstallId } from '../integration/util'
import { ConnectAccessGuard } from '../integration/access'
import { InstallationEditor } from '../integration.install/InstallationEditor'

function ConnectMarketplaceInstallationPage(): ReactElement {
  const { appId, installId } = Route.useParams()
  const parsedAppId = parseConnectAppId(appId)
  const parsedInstallId = parseConnectInstallId(installId)

  if (!parsedAppId || !parsedInstallId) {
    return (
      <ConnectAccessGuard>
        <NotReady error='Invalid installation path' id='installation' />
      </ConnectAccessGuard>
    )
  }

  return <InstallationEditor installId={parsedInstallId} />
}

export const Route = createFileRoute('/integration/marketplace_/$appId/$installId/')({
  component: ConnectMarketplaceInstallationPage,
})
